import { ArticleAdditionalFeedbackTypeNegative } from '@wix/answers-api';
import { Box, Button, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useState } from 'react';

import { ChatMessage } from './ChatMessage';
import { MessageSender } from './MessageSender';
import { UnhelpfulFeedbackOptions } from './UnhelpfulFeedbackOptions';
import { DATA_HOOKS } from '../../../dataHooks';
import { ChevronLeftBoldIcon } from '../../../icons/ChevronLeftBoldIcon';
import { useStore } from '../../../zustand/stores';

import css from './index.module.scss';


export const UnhelpfulFeedbackChat = () => {
  const { setShowUnhelpfulFeedback } = useStore(state => state.copilotSlice);
  const { t } = useTranslation();
  const [unhelpfulFeedbackOptionSelected, setUnhelpfulFeedbackOptionSelected] =
    useState<ArticleAdditionalFeedbackTypeNegative | null>(null);
  return (

    <Box className={css.wrapper} direction="vertical" gap="3">
      <Box className={css.titleWrapper} align="space-between">
        <Box>
          <div
            onClick={() => setShowUnhelpfulFeedback(false)}
            className={css.backButton}
            data-hook={DATA_HOOKS.UNHELPFUL_FEEDBACK_BACK_BUTTON}
          >
            <ChevronLeftBoldIcon />
          </div>
          <Text size="medium" weight="bold" >{t('article-page.copilot.chatbot')}</Text>
        </Box>
        <Box>
          {/* TODO: add functionality for start over */}
          <Button skin="dark" priority="secondary" size="tiny">
            {t('article-page.copilot.unhelpful-feedback.start-over')}
          </Button>
        </Box>
      </Box>
      <Box direction="vertical" gap={2}>
        <ChatMessage message={t('article-page.copilot.unhelpful-feedback.message')} />
        <MessageSender />
        <UnhelpfulFeedbackOptions
          setUnhelpfulFeedbackOptionSelected={setUnhelpfulFeedbackOptionSelected}
        />
        {unhelpfulFeedbackOptionSelected === ArticleAdditionalFeedbackTypeNegative.OTHER && (
          <ChatMessage message={t('article-page.copilot.unhelpful-feedback.other-message')} />
          /* TODO: add chatbot entry point */
        )}
      </Box>
    </Box>
  );
};
